import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../@style/Footer.css';
import logo2 from '../assets/images/logo2.png';

const Footer = () => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <footer className={`footer ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-column footer-logo">
            <img src={logo2} alt={t('footer.logo_alt')} className="footer-logo-img" />
          </div>

          <div className="footer-column">
            <h3>{t('footer.pages')}</h3>
            <ul>
              <li>
                <Link to="/">{t('nav.home')}</Link>
              </li>
              <li>
                <Link to="/milyem">{t('nav.milyem')}</Link>
              </li>
              <li>
                <Link to="/hakkimizda">{t('nav.about')}</Link>
              </li>
              <li>
                <Link to="/uyum">{t('nav.compliance')}</Link>
              </li>
              <li>
                <Link to="/bilgi-toplum-hizmetleri">{t('nav.bilgiToplum')}</Link>
              </li>
              <li>
                <Link to="/iletisim">{t('nav.contact')}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>{t('footer.contact_info')}</h3>
            <p>{t('contact.phone.title')}</p>
            <p>
              <a href={`tel:${t('contact.phone.number')}`}>{t('contact.phone.number')}</a>
            </p>
            <p>{t('contact.email.title')}</p>
            <p>
              <a href={`mailto:${t('contact.email.address')}`}>{t('contact.email.address')}</a>
            </p>
            <p>{t('contact.phone.hours')}</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{t('footer.copyright')}</p>
          <div className="footer-bottom-links">
            <a href="/gizlilik-politikasi">{t('footer.privacy')}</a>
            <a href="/kullanim-sartlari">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
